/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AuditLogDto } from './AuditLogDto';
import {
    AuditLogDtoFromJSON,
    AuditLogDtoFromJSONTyped,
    AuditLogDtoToJSON,
    AuditLogDtoToJSONTyped,
} from './AuditLogDto';

/**
 * 
 * @export
 * @interface AuditStatisticsDto
 */
export interface AuditStatisticsDto {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof AuditStatisticsDto
     */
    categoryCounts?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof AuditStatisticsDto
     */
    severityCounts?: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof AuditStatisticsDto
     */
    successCount?: number;
    /**
     * 
     * @type {number}
     * @memberof AuditStatisticsDto
     */
    failureCount?: number;
    /**
     * 
     * @type {Array<AuditLogDto>}
     * @memberof AuditStatisticsDto
     */
    recentActivity?: Array<AuditLogDto>;
}

/**
 * Check if a given object implements the AuditStatisticsDto interface.
 */
export function instanceOfAuditStatisticsDto(value: object): value is AuditStatisticsDto {
    return true;
}

export function AuditStatisticsDtoFromJSON(json: any): AuditStatisticsDto {
    return AuditStatisticsDtoFromJSONTyped(json, false);
}

export function AuditStatisticsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditStatisticsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'categoryCounts': json['category_counts'] == null ? undefined : json['category_counts'],
        'severityCounts': json['severity_counts'] == null ? undefined : json['severity_counts'],
        'successCount': json['success_count'] == null ? undefined : json['success_count'],
        'failureCount': json['failure_count'] == null ? undefined : json['failure_count'],
        'recentActivity': json['recent_activity'] == null ? undefined : ((json['recent_activity'] as Array<any>).map(AuditLogDtoFromJSON)),
    };
}

export function AuditStatisticsDtoToJSON(json: any): AuditStatisticsDto {
    return AuditStatisticsDtoToJSONTyped(json, false);
}

export function AuditStatisticsDtoToJSONTyped(value?: AuditStatisticsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category_counts': value['categoryCounts'],
        'severity_counts': value['severityCounts'],
        'success_count': value['successCount'],
        'failure_count': value['failureCount'],
        'recent_activity': value['recentActivity'] == null ? undefined : ((value['recentActivity'] as Array<any>).map(AuditLogDtoToJSON)),
    };
}

